// SheetJS (xlsx) is loaded on demand from a CDN and exposed as window.XLSX.
// It is injected via a <script> tag rather than a webpack `import(...)` so CRA's
// webpack build does not try to bundle a remote ES module (which fails the build
// with "target environment doesn't support dynamic import()").
export const XLSX_CDN_URL =
  "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";

export function ensureXLSX() {
  if (window.XLSX) return Promise.resolve(window.XLSX);
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = XLSX_CDN_URL;
    s.onload = () => resolve(window.XLSX);
    s.onerror = reject;
    document.head.appendChild(s);
  });
}
